import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b884607e")

_pushScopeId("data-v-b884607e")
const _hoisted_1 = { class: "element-opacity" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "不透明度：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Slider, {
        min: 0,
        max: 1,
        step: 0.1,
        value: _ctx.opacity,
        style: {"flex":"3"},
        onChange: _cache[1] || (_cache[1] = value => _ctx.updateOpacity(value))
      }, null, 8, ["step", "value"])
    ])
  ]))
})